export default "__VITE_ASSET__vwYYx0QS__"